export class url {
    apiphp:string= 'https://payment.riskyid.com/api/api.php';//http://payment.riskyid.com
    apiback: string= 'https://api.riskyid.com/api/Account';
    apibackdavid: string= 'https://api.riskyid.com';
}

